import React, { memo } from "react";
import Separator from "./Separator.tsx";
import Icon from "./Icon.tsx";
import CloseIcon from "../../components/CloseIcon/CloseIcon";

interface CadastroEditHeaderProps {
	dadosTitle: string;
	headerTitle: string;
	onClick: () => void;
}

function CadastroEditHeader({
	dadosTitle,
	onClick,
	headerTitle,
}: CadastroEditHeaderProps) {
	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexDirection: "column",
				width: "100%",
				padding: "20px",
			}}
		>
			<div
				style={{
					width: "90%",
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<div
					style={{
						width: "29px",
						height: "29px",
					}}
				/>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<p className="indicador-emb">{dadosTitle}</p>
					<Separator direction="horizontal" size="xs" />
					<Icon name="ChevronRight" size="lg" theme="dark" />
					<Separator direction="horizontal" size="xs" />
					<p>{headerTitle}</p>
				</div>
				<CloseIcon onClick={onClick} />
			</div>
		</div>
	);
}

export default memo(CadastroEditHeader);
